import React, { useRef } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';

import { PUBLIC_KEYS } from "core/config/stripeConfig";
import useCart from "pages/Components/CartPage/hooks/useCart";

type Props = {
    children?: React.ReactNode,
};

const StripeLoader: React.FC<Props> = ({ children }) => {
    const stripeKey = useRef('none');
    const { getCountry } = useCart();
    const cartCountryCode = getCountry();

    const countryCodeSelected = cartCountryCode.code.toLowerCase();

    stripeKey.current = (
        PUBLIC_KEYS.find(keySet => keySet.country === countryCodeSelected)?.key ??
        PUBLIC_KEYS.find(keySet => keySet.country === 'default')?.key
    ) || '';

    const stripePromise: any = loadStripe(stripeKey.current);

    if (!stripePromise) {
        return <div />;
    }

    return (
        // key is necessary to ensure Stripe updates country on country change.
        <Elements key={stripeKey.current} stripe={stripePromise}>
            {children}
        </Elements>
    );
};

export default StripeLoader;
